// extracted by mini-css-extract-plugin
export var button = "_mn-0";
export var donut = "_mn-1";
export var donutFill = "_mn-3";
export var donutTrack = "_mn-2";